// Generated by purs version 0.15.15
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
var genericShowConstructor = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments);
var MkLoadingIsSymbol = {
    reflectSymbol: function () {
        return "MkLoading";
    }
};
var Loading = /* #__PURE__ */ (function () {
    function Loading() {

    };
    Loading.value = new Loading();
    return Loading;
})();
var Loaded = /* #__PURE__ */ (function () {
    function Loaded() {

    };
    Loaded.value = new Loaded();
    return Loaded;
})();
var MkLoading = /* #__PURE__ */ (function () {
    function MkLoading(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    MkLoading.create = function (value0) {
        return function (value1) {
            return new MkLoading(value0, value1);
        };
    };
    return MkLoading;
})();
var semigroupLoadingStatus = {
    append: function (v) {
        return function (v1) {
            if (v instanceof Loading) {
                return Loading.value;
            };
            if (v1 instanceof Loading) {
                return Loading.value;
            };
            if (v instanceof Loaded && v1 instanceof Loaded) {
                return Loaded.value;
            };
            throw new Error("Failed pattern match at Data.Loading (line 9, column 1 - line 12, column 32): " + [ v.constructor.name, v1.constructor.name ]);
        };
    }
};
var append = /* #__PURE__ */ Data_Semigroup.append(semigroupLoadingStatus);
var monoidLoadingStatus = /* #__PURE__ */ (function () {
    return {
        mempty: Loaded.value,
        Semigroup0: function () {
            return semigroupLoadingStatus;
        }
    };
})();
var mempty = /* #__PURE__ */ Data_Monoid.mempty(monoidLoadingStatus);
var genericLoadingStatus_ = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return Loading.value;
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return Loaded.value;
        };
        throw new Error("Failed pattern match at Data.Loading (line 17, column 1 - line 17, column 40): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Loading) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof Loaded) {
            return new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value);
        };
        throw new Error("Failed pattern match at Data.Loading (line 17, column 1 - line 17, column 40): " + [ x.constructor.name ]);
    }
};
var showLoadingStatus = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericLoadingStatus_)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "Loading";
        }
    }))(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "Loaded";
        }
    })))
};
var genericShowArgsProduct = /* #__PURE__ */ Data_Show_Generic.genericShowArgsProduct(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(showLoadingStatus));
var eqLoadingStatus = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Loading && y instanceof Loading) {
                return true;
            };
            if (x instanceof Loaded && y instanceof Loaded) {
                return true;
            };
            return false;
        };
    }
};
var unLoading = function (v) {
    return v.value1;
};
var semigroupLoading = function (dictSemigroup) {
    var append1 = Data_Semigroup.append(dictSemigroup);
    return {
        append: function (v) {
            return function (v1) {
                return new MkLoading(append(v.value0)(v1.value0), append1(v.value1)(v1.value1));
            };
        }
    };
};
var monoidLoading = function (dictMonoid) {
    var semigroupLoading1 = semigroupLoading(dictMonoid.Semigroup0());
    return {
        mempty: new MkLoading(mempty, Data_Monoid.mempty(dictMonoid)),
        Semigroup0: function () {
            return semigroupLoading1;
        }
    };
};
var loading = /* #__PURE__ */ (function () {
    return MkLoading.create(Loading.value);
})();
var loaded = /* #__PURE__ */ (function () {
    return MkLoading.create(Loaded.value);
})();
var genericLoading = {
    to: function (x) {
        return new MkLoading(x.value0, x.value1);
    },
    from: function (x) {
        return new Data_Generic_Rep.Product(x.value0, x.value1);
    }
};
var genericShow = /* #__PURE__ */ Data_Show_Generic.genericShow(genericLoading);
var showLoading = function (dictShow) {
    return {
        show: genericShow(Data_Show_Generic.genericShowConstructor(genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow)))(MkLoadingIsSymbol))
    };
};
var functorLoading = {
    map: function (f) {
        return function (m) {
            return new MkLoading(m.value0, f(m.value1));
        };
    }
};
export {
    Loading,
    Loaded,
    MkLoading,
    unLoading,
    loaded,
    loading,
    eqLoadingStatus,
    semigroupLoadingStatus,
    monoidLoadingStatus,
    genericLoadingStatus_,
    showLoadingStatus,
    functorLoading,
    genericLoading,
    showLoading,
    semigroupLoading,
    monoidLoading
};
